


const contentArr = [
    {
        heading: "Inventors of Multifiber",
        content: "Testfabrics, Inc. acquired Elkay Weaving Co. in 1965, which had been the sole producer of special multifiber fabrics for over 15 years. This acquisition allowed Testfabrics, Inc. to have increased control over the production of its core products. The multifiber fabrics developed by Testfabrics, Inc. were recognized as international reference standards in 1989. These fabrics are used in various testing methods and are recognized by organizations such as AATCC and ISO."
    },
    {
        heading: "Research & Development (R&D)",
        content: "Testfabrics, Inc. places strong emphasis on research and development that is driven directly by the needs and feedback of their clients. By working closely with chemists, colorists, and textile laboratories, Testfabrics continuously innovates and refines their textile test materials to keep pace with the evolving demands of the textile industry. Their R&D efforts focus on creating reliable, standardized fabrics that improve the accuracy and relevance of quality control and testing processes worldwide. This client-centered approach ensures that Testfabrics’ products remain cutting-edge and highly effective for a wide range of textile testing applications."
    },
    {
        heading: "Discovery Box",
        content: "While Testfabrics, Inc. does not explicitly label a “Discovery Box” program, their approach to innovation can be understood as a collaborative and exploratory process akin to a “Discovery Box.” This involves actively engaging with customers and professional organizations such as AATCC and ISO to identify emerging challenges in textile testing. Through this collaborative model, Testfabrics develops new and improved test fabrics-such as multifiber adjacent fabrics used in colorfastness testing-and custom solutions that address specific industry needs. This ongoing discovery process helps the company stay ahead of trends and continuously expand their product offerings."
    },
    {
        heading: "Forward-Facing Relevance",
        content: "Testfabrics maintains forward-facing relevance by supplying standardized test textiles certified by international bodies like ISO and AATCC, which serve as essential reference materials in global textile testing protocols.Actively participating in industry research committees and professional associations to anticipate future testing requirements and contribute to the development of new standards. Offering customized services such as dyeing, soiling, and specimen preparation to support innovation and quality assurance in textile manufacturing and research. Embracing technological advancements and client feedback to develop specialized products that meet evolving industry challenges."
    },
]

const InnovationContent = () => {

    return (
        <section className="timeline-wrapper section-padding">
            <div className="container">
                <div className="row mb-30">
                    <div className="col-12 col-lg-12">
                        <div className="section-title text-left mt-3">
                            <h2>Innovation</h2>
                        </div>
                    </div>
                </div>
            </div>
            
            {
                contentArr.map((content,index) => (
                        <div key={"content"+index} className="container mb-3" >
                            <h4>{content.heading}</h4>
                            <p>{content.content}</p>
                        </div>
                ))
            }
            
        </section>
    );

}



export default InnovationContent;